import type { NextPage } from 'next';

import { AboutContainer } from '../routes/about/About.container';

const About: NextPage = () => {
  return <AboutContainer />;
};

About.getInitialProps = function () {
  return {
    metadata: {
      title: 'About',
    },
  };
};

// Not applicable to Pages
// eslint-disable-next-line import/no-default-export
export default About;
